import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import getDeviceId from 'utils/getDeviceId'
import store from 'store'

const deviceId = getDeviceId()
Bugsnag.start({
  apiKey: '3b5c729edd509161c152f4771962a054',
  appVersion: process.env.__version__,
  collectUserIp: true,
  enabledErrorTypes: {
    unhandledExceptions: false,
    unhandledRejections: false
  },
  plugins: [new BugsnagPluginVue()],
  onError(evt) {
    evt.addMetadata('env', {
      deviceId,
      timestamp: new Date().getTime(),
      account: store.getters.curAccountId,
      virtual: store.getters.isVirtual
    })
    evt.setUser(store.getters.curAccountId, '***', store.getters.username)
  }
})
const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

Vue.log = Bugsnag.notify
